module.exports = __webpack_public_path__ + "static/media/banner.85c24f83.jpg";